<div class="border border-2 bg-white rounded border-primary">
  <div class="card-body">
    <form *ngIf="form" [formGroup]="form" class="row mx-0 justify-content-center align-items-center">
      <div class="col-md-3 p-2" *ngIf="hasDateRanges">
        <label class="text-primary">{{ 'Sellers.Products.SelectDate' | translate }}</label>
        <input class="form-control" type="text" ngxDaterangepickerMd [locale]="{ applyLabel: 'ok', format: 'DD/MM/YYYY' }"
               formControlName="createdAt" placeholder="{{ 'Sellers.Products.SelectDateRange' | translate }}" [showCustomRangeLabel]="true"
               [singleDatePicker]="singleDates" [linkedCalendars]="true" [showClearButton]="true"
               [alwaysShowCalendars]="true" [autoApply]="singleDates" [ranges]="singleDates? []: ranges" />
        <small *ngIf="formValidator.formErrors.createdAt">
          {{ formValidator.formErrors.createdAt }}
        </small>
      </div>
      <div class="col-md-3 p-2" *ngFor="let field of filterFields">
        <div *ngIf="field.filterOptions">
          <label class="text-primary">{{ field.filterDisplayName }}</label>

          <div class="form-control">
            <app-menu
            [data]="field"
            [isRoot]="true"
            (optionSelected)="onOptionSelected($event)"
            ></app-menu>
          </div>

        </div>
        <div *ngIf="!field.filterOptions">
          <label class="text-primary">{{ field.filterDisplayName }}</label>
          <input class="form-control" type="text" [formControlName]="field.filterFieldName"
                 placeholder="{{ field.filterFieldName }}" />
          <small *ngIf="formValidator.formErrors[field.filterFieldName]">
            {{ formValidator.formErrors[field.filterFieldName] }}
          </small>
        </div>
      </div>
      <div class="col-md-3 p-2">
        <button type="submit" (click)="filter()" class="mt-4 btn btn-primary w-100"
                [disabled]="form.invalid">
          {{ 'Sellers.Products.Filter' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>

